"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLIDER_DEFAULT_LABEL_TEXTS = void 0;
exports.SLIDER_DEFAULT_LABEL_TEXTS = {
    minValueLabel: 'Min value',
    maxValueLabel: 'Max value'
};
//# sourceMappingURL=constants.js.map